import {Component, Input} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
    selector: 'app-text-input',
    templateUrl: './text-input.component.html',
    standalone: false
})
export class TextInputComponent {

  @Input() formGroup : FormGroup
  /** Classes do campo de texto (tamanho normal do PrimeNG para boa altura com FloatLabel). */
  @Input() inputClass = 'w-full'
  @Input() id : string
  @Input() type : string
  @Input() placeholder : string
  @Input() label : string
  @Input() maxLength : number
  @Input() value : string
  @Input() formError : string
  @Input() hideCounter : boolean
  @Input() disabled = false

  isFocused = false
}
